import { useEffect, useState } from 'react';

import { MOBILE_BREAKPOINT, SMALL_MOBILE_BREAKPOINT } from '#/utils/constants';

/**
 * Returns a responsive maxLength for truncation based on window width.
 * - <= 375px: 30
 * - < 576px: 40
 * - >= 576px: desktopMaxLength (default 30)
 */

function useResponsiveTextTruncation({ desktopMaxLength = 30 } = {}) {
  const [maxLength, setMaxLength] = useState(desktopMaxLength);

  useEffect(() => {
    const calculateMaxLength = () => {
      const width = window.innerWidth;

      if (width <= SMALL_MOBILE_BREAKPOINT) {
        setMaxLength(30);
      } else if (width < MOBILE_BREAKPOINT) {
        setMaxLength(40);
      } else {
        setMaxLength(desktopMaxLength);
      }
    };
    calculateMaxLength();

    window.addEventListener('resize', calculateMaxLength);
    return () => window.removeEventListener('resize', calculateMaxLength);
  }, [desktopMaxLength]);

  return maxLength;
}

export default useResponsiveTextTruncation;
